import Download from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import precongres1 from './images/Precongress 1.webp';
import precongres2 from './images/Precongress 2.webp';
import precongres3 from './images/Precongress 3.webp';

const mock = [
    {
        media: precongres1,
        subtitle: 'Cardiogenic Shock in 2024',
        url: 'https://bit.ly/W22APRIL',
        isDownload: false,
    },
    {
        media: precongres2,
        subtitle: 'Enhancing Diagnostic Accuracy in Acute Heart Failure',
        url: 'https://bit.ly/W23APRIL',
        isDownload: false,
    },
    {
        media: precongres3,
        subtitle: 'Updates on Advanced Cardiopulmonary Resuscitation',
        url: 'https://bit.ly/W24APRIL',
        isDownload: false,
    },
];

const PreCongress = () => {
    const theme = useTheme();

    return (
        <Box>
            <Box marginBottom={4}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                    }}
                    gutterBottom
                    align={'center'}
                >
                    Pre Congress Announcement
                </Typography>
            </Box>
            <Grid container spacing={4}>
                {mock.map((item, i) => (
                    <Grid
                        item
                        xs={12}
                        md={4}
                        key={i}
                        data-aos={'fade-up'}
                        data-aos-delay={i * 100}
                        data-aos-offset={100}
                        data-aos-duration={600}
                    >
                        <Box
                            display={'block'}
                            width={1}
                            height={1}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                '&:hover': {
                                    transform: `translateY(-${theme.spacing(
                                        1 / 2,
                                    )})`,
                                },
                            }}
                        >
                            <Box
                                component={Card}
                                width={1}
                                height={1}
                                display={'flex'}
                                flexDirection={'column'}
                                sx={{ backgroundImage: 'none' }}
                            >
                                <Box
                                    component={CardMedia}
                                    borderRadius={2}
                                    width={1}
                                    height={1}
                                    minHeight={370}
                                    image={item.media}
                                />
                                <CardContent>
                                    <Typography
                                        variant={'h6'}
                                        gutterBottom
                                        sx={{ fontWeight: 700 }}
                                        align={'center'}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography
                                        align={'center'}
                                        variant={'subtitle2'}
                                        color="text.secondary"
                                    >
                                        {item.subtitle}
                                    </Typography>
                                </CardContent>
                                <Box flexGrow={1} />
                                <CardActions sx={{ justifyContent: 'center' }}>
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <Button>Go To Pre Congress</Button>
                                    </a>
                                </CardActions>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default PreCongress;
